import { TextField, InputAdornment, Tooltip, IconButton, Box, LinearProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface IProps {
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  isAiSearch: boolean;
  setIsAiSearch: (on: boolean) => void;
  onSearch: () => void;
  isLoading: boolean;
}

export const SearchBar = ({
  searchQuery,
  setSearchQuery,
  isAiSearch,
  setIsAiSearch,
  onSearch,
  isLoading
}: IProps) => {
  return (
    <Box id="index__components-home-search-bar__box__l23"
    sx={{
      position: 'relative',
      my: '20px',
      maxWidth: '500px',
      width: '100%'
    }}>
      
      <TextField id="index__components-home-search-bar__textfield__l31"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={(e) => {
        // if (isAiSearch && searchQuery === '') return
        if (e.key === 'Enter') {
          onSearch();
        }
      }}
      variant="outlined"
      placeholder="Ask Traicy…"
      fullWidth
      InputProps={{
        endAdornment:
        <InputAdornment id="index__components-home-search-bar__inputadornment__l45" position="end" sx={{ display: 'flex', gap: 1 }}>
              <Tooltip id="index__components-home-search-bar__tooltip__l46" title={'Use AI Search'}>
                <IconButton id="index__components-home-search-bar__iconbutton__l47" onClick={() => setIsAiSearch(!isAiSearch)} size="small">
                  <AutoAwesomeIcon color={isAiSearch ? 'primary' : 'inherit'} />
                </IconButton>
              </Tooltip>
              <IconButton id="index__components-home-search-bar__iconbutton__l51"
          onClick={onSearch}
          size="small"
          // disabled={isAiSearch && searchQuery.trim() === ''}
          >
                <SearchIcon color={'inherit'} />
              </IconButton>
            </InputAdornment>

      }}
      // sx={{ my: '20px', maxWidth: '500px' }}
      />

      {isLoading &&
      <LinearProgress
        sx={{
          position: 'absolute',
          left: '15px',
          right: '15px',
          bottom: '-10px',
          height: 3,
          borderRadius: 1
        }} />

      }
    </Box>);

};